import { useApiQuery } from 'theSource/utils';
import { PlanInfoResponseDto } from './utils';

export interface UsePlanInfoQueryProps {
  orgPlanYearId?: number;
  enrollmentContext?: string;
  lifeEventCompleted?: boolean;
  orgPlanId: number;
  enabled?: boolean;
}

export const usePlanInfoQuery = ({
  orgPlanYearId,
  enrollmentContext,
  lifeEventCompleted,
  orgPlanId,
  enabled = true,
}: UsePlanInfoQueryProps) => {
  const {
    data: planInfoData,
    isLoading: isLoadingPlanInfo,
    isFetching: isFetchingPlanInfo,
  } = useApiQuery<PlanInfoResponseDto>({
    queryKey: orgPlanId + '_planInfo',
    // config: {
    //   baseURL: `${lumosApiHost}/v2/self_service`,
    // },
    endpoint: `/benefits/plan_information/${orgPlanId}`,
    params: {
      org_plan_year_id: orgPlanYearId,
      enrollment_context_type: enrollmentContext,
      life_event_completed: lifeEventCompleted,
    },
    enabled: enabled,
  });

  return {
    planInfoData,
    isLoadingPlanInfo,
    isFetchingPlanInfo,
  };
};
